import { createContext, useContext } from 'react';
import { MoralRiskStudyCommandActions } from '../../domain';
import { GqlMoralRiskStudyCommandActions } from '../gql';

type MoralRiskStudyActionsContextT = {
  moralRiskStudyCommandActions: MoralRiskStudyCommandActions;
};

export const moralRiskDefaultValue: MoralRiskStudyActionsContextT = {
  moralRiskStudyCommandActions: GqlMoralRiskStudyCommandActions,
};

export const moralRiskStudyActionsContext = createContext<MoralRiskStudyActionsContextT>(moralRiskDefaultValue);

export const useMoralRiskStudyActions = (): MoralRiskStudyActionsContextT => useContext(moralRiskStudyActionsContext);
